import React, { useCallback } from "react";
import ModalWrapper from "..";
import { Button } from "../../button";
import toast from "react-hot-toast";
import { useDeleteLocationById } from "../../../hooks/common/mutation";
import useAuthStore from "../../../store/Auth";
import { useTranslation } from "react-i18next";
import { DELETE_STATUSES } from "../../../constants/common";

interface DeleteLocationModalProps {
  locationId: number;
  isOpen: boolean;
  onOpenChange: () => void;
}

const DeleteLocationModal = ({
  locationId,
  isOpen,
  onOpenChange,
}: DeleteLocationModalProps) => {
  const {
    mutateAsync: DeleteLocationById,
    isPending: isDeleteLocationByIdLoading,
  } = useDeleteLocationById();

  const user = useAuthStore((state) => state.user);
  const { t } = useTranslation();

  const handleDeleteLocation = useCallback(async () => {
    try {
      if (user?.user_id) {
        const body = {
          encryptedId: locationId.toString(),
          encryptedUserId: user?.user_id.toString(),
        };

        await DeleteLocationById(body);
        toast.success(t("locationDeleted"));
      }
    } catch (error: any) {
      if (error.result.deleteStatus === DELETE_STATUSES.USED_IN_DEPARTMENT) {
        toast.error(t("locationNotDeletedUsedByDepartments"));
      } else {
        toast.error(t("somethingWentWrong"));
      }
    } finally {
      onOpenChange();
    }
  }, [DeleteLocationById, t, locationId, onOpenChange, user?.user_id]);

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col gap-8 justify-center items-center">
        <p className="text-lg md:text-2xl font-medium">
          {t("confirmDeleteLocation")}
        </p>

        <div className="flex gap-1 items-center">
          <Button
            onClick={handleDeleteLocation}
            isLoading={isDeleteLocationByIdLoading}
            className=" bg-red-600 hover:bg-red-700"
          >
            {t("delete")}
          </Button>

          <Button onClick={onOpenChange}>{t("close")}</Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(DeleteLocationModal);
